module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/contact_collector-4a748cde52bd3927a433685556bf4c3c.jpg";